import { useEffect, useState } from 'react'
import { useAccount } from '@lib/context/account-context'
import axios from 'axios'
import { AVOCADO_CONSTANT } from '@lib/constants'
import { useCart } from 'medusa-react'
import { toast } from 'react-toastify'
import {
  Box,
  Button,
  CircularProgress,
  Table,
  TableContainer,
  Tbody,
  Th,
  Thead,
  Tr
} from '@chakra-ui/react'
import _ from 'lodash'
import AvocadoPin from '@components/modals/advocado/avocado-pin'
import { medusaClient, medusaRequest } from '@lib/config'
import { handleError } from '@lib/util/handle-error'
import { confirmAlert } from 'react-confirm-alert'
import useAdvocado from '@common/hooks/use-advocado'
import 'react-confirm-alert/src/react-confirm-alert.css'

const AvocadoDetail = ({
  campaigns,
  userPoints,
  handleGetObtaiCampain
}: {
  campaigns: any
  userPoints: number
  handleGetObtaiCampain: any
}) => {
  const { avocado, setAvocado, handleGetAvocadoUser } = useAccount()
  const { cart, setCart } = useCart()

  const [campainData, setCampainData] = useState<any>(null)
  const [indexRedeem, setIndexRedeem] = useState<any>(null)
  const [isOpenPin, setIsOpenPin] = useState<any>(null)

  const handleRender = () => {
    const renders: any = {
      points: null,
      voucher: []
    }

    avocado?.avocadoInfo?.campaignBalances?.map((item: any) => {
      const campaign = campaigns.find((c: any) => c.id === item.campaignId)

      if (!campaign) return

      item.campaign = campaign

      const campaignRedeemTemplate: any = {
        campaignId: campaign.id,
        campaignType: campaign.type,
        isSend: true
      }

      if (item.campaignType == 'loyalty' || item.campaignType == 'stamps') {
        renders.points = (
          <TableContainer>
            <Box overflowY="auto" maxHeight="210px">
              <Table variant="simple">
                <Thead position="sticky" top={0} bgColor="white" zIndex={100}>
                  <Tr>
                    <Th>Name</Th>
                    <Th>Points</Th>
                    <Th>Action</Th>
                  </Tr>
                </Thead>
                <Tbody
                  className="overflow-y-scroll"
                  style={{
                    maxHeight: 200
                  }}
                >
                  {item.campaign?.redeem?.map((redeem: any) => {
                    const campaignRedeem = _.cloneDeep(campaignRedeemTemplate)
                    campaignRedeem.value = redeem.value
                    campaignRedeem.type = redeem.type
                    campaignRedeem.optionId = redeem.id
                    campaignRedeem.name = redeem.description

                    if (item.itemPrice != undefined) {
                      campaignRedeem.itemPrice = item.itemPrice
                    } else {
                      campaignRedeem.itemPrice = 0
                    }

                    if (redeem.type == 'item') {
                      campaignRedeem.itemSku = redeem.sku[0]?.itemSku
                    }

                    if (redeem.redeemPoint > userPoints) return null

                    return (
                      <Tr key={Math.random()}>
                        <Th>{redeem.description}</Th>
                        <Th>{redeem.redeemPoint}</Th>
                        <Th>
                          <Button
                            variant="outline"
                            size="xs"
                            isDisabled={!!indexRedeem}
                            onClick={() => {
                              setIndexRedeem(redeem.id)
                              handleConfirmPromotionAndUsedAvocado(
                                campaignRedeem
                              )
                            }}
                          >
                            redeem
                            {indexRedeem === redeem.id && (
                              <CircularProgress
                                isIndeterminate
                                size={3}
                                color="black"
                                className="ml-2"
                              />
                            )}
                          </Button>
                        </Th>
                      </Tr>
                    )
                  })}
                </Tbody>
              </Table>
            </Box>
          </TableContainer>
        )
      } else {
        const campaignRedeem = _.cloneDeep(campaignRedeemTemplate)

        campaignRedeem.type = item.campaign.voucherType
        campaignRedeem.value = item.campaign.voucherValue + ''
        campaignRedeem.name = item.campaign.name

        if (item.itemPrice) {
          campaignRedeem.itemPrice = item.itemPrice
        }
        if (item.itemPrice != undefined) {
          campaignRedeem.itemPrice = item.itemPrice
        } else {
          campaignRedeem.itemPrice = 0
        }

        if (item.campaign.voucherType == 'item') {
          campaignRedeem.itemSku = item.campaign.extSkuMapping[0]?.itemSku
        }

        if (item.vouchers > 0) {
          renders.voucher.push(
            <Tr key={Math.random()}>
              <Th
                style={{
                  maxWidth: 150,
                  whiteSpace: 'pre-wrap'
                }}
              >
                {item.campaign.name}
              </Th>
              <Th>{item.vouchers}</Th>
              <Th>
                <Button
                  variant="outline"
                  size="xs"
                  isDisabled={!!indexRedeem}
                  onClick={() => {
                    setIndexRedeem(item.campaignId)
                    handleConfirmPromotionAndUsedAvocado(campaignRedeem)
                  }}
                >
                  redeem
                  {indexRedeem === item.campaignId && (
                    <CircularProgress
                      isIndeterminate
                      size={3}
                      color="black"
                      className="ml-2"
                    />
                  )}
                </Button>
              </Th>
            </Tr>
          )
        }
      }

      return item
    })

    renders.voucher = (
      <TableContainer>
        <Box overflowY="auto" maxHeight="210px">
          <Table variant="simple">
            <Thead position="sticky" top={0} bgColor="white" zIndex={100}>
              <Tr>
                <Th>Name</Th>
                <Th>Qty</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody
              className="overflow-y-scroll"
              style={{
                maxHeight: 200
              }}
            >
              {renders.voucher}
            </Tbody>
          </Table>
        </Box>
      </TableContainer>
    )

    setCampainData(renders)
  }

  const handleConfirmPinAndUsedAvocado = (campaignRedeem: any) => {
    if (!avocado?.pin) {
      setIsOpenPin(
        <AvocadoPin
          isOpen={true}
          onCloseHandler={() => {
            setIndexRedeem(null)
            setIsOpenPin(null)
          }}
          onRedeem={(pin, setRedeeming) => {
            if (avocado?.pin || pin) {
              handleApplyAvocado(pin, campaignRedeem, setRedeeming)
            }
          }}
        />
      )
      return
    }

    handleApplyAvocado(avocado.pin, campaignRedeem)
  }

  const handleConfirmPromotionAndUsedAvocado = (campaignRedeem: any) => {
    if (hasPromotionHaveExist()) {
      console.log('Alert confirm')

      confirmAlert({
        title: (<span className="font-bold">Waring</span>) as any,
        message:
          'Are you sure to do this, promotion applied will remove after use avocado',
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              handleConfirmPinAndUsedAvocado(campaignRedeem)
            }
          },
          {
            label: 'No',
            onClick: () => {
              setIndexRedeem(null)
              console.log('No')
            }
          }
        ]
      })

      return
    }

    handleConfirmPinAndUsedAvocado(campaignRedeem)
  }

  const hasPromotionHaveExist = () => {
    return cart?.items.some((item) =>
      item.adjustments.some((adj: any) => adj.promotion_id)
    )
  }

  const handleApplyAvocado = async (
    pin: string,
    redeemObj: any,
    setRedeeming?: (input: boolean) => void
  ) => {
    try {
      const applyObj: any = {
        cartId: cart?.id,
        pin: avocado?.pin ?? pin,
        customerId: avocado?.avocadoInfo.id,
        transactionsRedemption: [redeemObj]
      }

      setAvocado((pre: any) => {
        return { ...pre, pin: avocado?.pin ?? pin }
      })

      const { data } = await medusaRequest(
        'POST',
        AVOCADO_CONSTANT.apply_avocado,
        applyObj
      )

      if (data.data.status == 'fail') {
        handleError(data.data.data)
        setAvocado((pre: any) => ({ ...pre, pin: null }))
        throw new Error(data.data.data)
      }

      const { cart: result } = await medusaClient.carts.retrieve(cart?.id ?? '')

      setCart(result)

      await handleGetAvocadoUser(avocado?.token || '')
      await handleGetObtaiCampain()
      setIndexRedeem(null)
      setIsOpenPin(false)
      if (setRedeeming != null) {
        setRedeeming(false)
      }
    } catch (e) {
      if (setRedeeming != null) {
        setRedeeming(false)
      }
      toast((e as any).message, {
        type: 'error'
      })
    }
  }

  useEffect(() => {
    handleRender()
  }, [indexRedeem, avocado])

  return (
    <>
      <h1 className="mb-2 font-bold">Advocado Available Rewards</h1>
      <h1 className="mb-2 font-bold">
        Loyalty Points - Current Points:{' '}
        {avocado?.avocadoInfo?.campaignBalances.find(
          (c: any) => c.campaignType == 'loyalty'
        ).points + '' || '0'}
      </h1>
      {campainData?.points}
      <h1 className="mt-2 mb-2 font-bold">Vouchers</h1>
      {campainData?.voucher}
      {isOpenPin}
    </>
  )
}

const Avocado = () => {
  const { avocado, customer } = useAccount()
  const { cart } = useCart()
  const [campaigns, setCampains] = useState<any>(null)

  const { verifyAdvocado, loadAdvocadoPDPAModal, loadAdvocadoSignupModal } =
    useAdvocado()

  const handleGetObtaiCampain = async () => {
    try {
      if (!avocado?.token) return

      const { data } = await axios.get(AVOCADO_CONSTANT.get_obtain_campaign, {
        headers: {
          Authorization: 'Bearer ' + avocado?.token
        }
      })

      if (data.status === 'success') {
        const campaigns = data.data

        setCampains(_.cloneDeep(campaigns))
      }
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    handleGetObtaiCampain()
  }, [avocado?.avocadoInfo, avocado?.pin, cart])

  return (
    <>
      <div className="p-6 bg-white">
        {!avocado?.avocadoInfo || avocado?.avocadoInfo.pdpa == '0' ? (
          <h3 className="text-base-semi">
            Start collecting points from your purchase for rebates! Be our
            Habbit Member today. <br />
            {!customer ? (
              <span
                className="underline cursor-pointer"
                onClick={verifyAdvocado}
              >
                JOIN AND COLLECT POINTS NOW
              </span>
            ) : (
              <span
                className="underline cursor-pointer"
                onClick={verifyAdvocado}
              >
                JOIN AND COLLECT POINTS NOW
              </span>
            )}
          </h3>
        ) : (
          campaigns &&
          avocado?.avocadoInfo &&
          avocado?.avocadoInfo?.pdpa == '1' && (
            <AvocadoDetail
              userPoints={
                avocado?.avocadoInfo?.campaignBalances?.find(
                  (c: any) => c.campaignType == 'loyalty'
                ).points || '0'
              }
              campaigns={campaigns}
              handleGetObtaiCampain={handleGetObtaiCampain}
            />
          )
        )}
      </div>
      {loadAdvocadoPDPAModal()}
      {loadAdvocadoSignupModal()}
    </>
  )
}

export default Avocado
